<template>
  <div>

    <div style="margin: 20px">
      注意：从其他设备同步后，本设备的身份信息将会丢失
    </div>
    <el-form ref="form" :model="form" label-width="100px">


      <el-form-item label="代码">
        <el-input v-model="form.code"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onExtend">立即绑定</el-button>
      </el-form-item>
    </el-form>
  </div>


</template>

<script>
import axios from '@/utils/request'

export default {
  name: 'Home',
  data() {
    return {
      form: {
        code: "",
      }
    }
  },
  methods: {

    onExtend() {
      axios.post("/extendTeacherInfo", {otherUUID: this.form.code})
    }
  },
  mounted() {

  },
  created() {

  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
